import { render, staticRenderFns } from "./more-benefit.vue?vue&type=template&id=9b34cbf8&scoped=true&"
import script from "./more-benefit.vue?vue&type=script&lang=js&"
export * from "./more-benefit.vue?vue&type=script&lang=js&"
import style0 from "./more-benefit.vue?vue&type=style&index=0&id=9b34cbf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b34cbf8",
  null
  
)

export default component.exports